export const numbersInCells = (cells) => {
  cells.forEach(cell => {
    const value = cell.innerText.replace(/[,\s%]/g, ""); // Remove whitespace
    // Testing if cell contains number or not
    if (!/[a-zA-Z]+/.test(value) && value !== '') {
      cell.classList.add('is-number');
    }
  });
};
